import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EB_ROUTES } from "./entity-builder.routes";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { LunaCommonModule } from "../common/common.module";
import { RouterModule } from "@angular/router";
//import { DragulaModule } from "ng2-dragula";
import { EntityBuilderComponent } from "./components/entitybuilder/entitybuilder.component";
import { EntityListComponent } from "./components/entitylist/entitylist.component";
import { UniqueEntityDirective } from "./directives/unique-entity.directive";
import { EntityResolver } from "./resolvers/entity.resolver";
//import { AutosizeModule } from "ngx-autosize";
import { StringComponent } from "./components/dynamic-components/string.component";
import { EbComponentHostDirective } from "./directives/ebcomponent-host.directive";
import { BoolComponent } from "./components/dynamic-components/bool.component";
import { NumberComponent } from "./components/dynamic-components/number.component";
import { StringFormComponent } from "./components/dynamic-components/string-form.component";
import { BoolFormComponent } from "./components/dynamic-components/bool-form.component";
import { NumberFormComponent } from "./components/dynamic-components/number-form.component";
import { EditEntityComponent } from "./components/entitybuilder/edit-entity.component";
import { ArrayFormComponent } from "./components/dynamic-components/array-form.component";
import { ObjectFormComponent } from "./components/dynamic-components/object-form.component";
import { ObjectComponent } from "./components/dynamic-components/object.component";
import { ArrayComponent } from "./components/dynamic-components/array.component";
import { EbInnerComponentHostDirective } from "./directives/eb-inner-component-host.directive";
import { ComponentService } from "./services/component-service.service";
import { EbComponentItem } from "./models/eb-component-item";
import { EntityBuilderItem } from "./models/entity-builder-item";

@NgModule({ declarations: [
        EntityBuilderComponent,
        EntityListComponent,
        UniqueEntityDirective,
        EbComponentHostDirective,
        StringComponent,
        BoolComponent,
        NumberComponent,
        StringFormComponent,
        BoolFormComponent,
        NumberFormComponent,
        EditEntityComponent,
        ArrayFormComponent,
        ObjectFormComponent,
        ObjectComponent,
        ArrayComponent,
        EbInnerComponentHostDirective
    ], imports: [CommonModule,
        LunaCommonModule,
        //DragulaModule,
        ReactiveFormsModule,
        RouterModule.forChild(EB_ROUTES),
        //AutosizeModule, possibly replace with @angular/cdk if its truly needed
        FormsModule], providers: [
        EntityResolver,
        ComponentService,
        { provide: EntityBuilderItem, useClass: EbComponentItem },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class EntityBuilderModule {}
